module.exports = __webpack_public_path__ + "assets/img/goods-demo03.d575ff1d.png";